import { useMemo } from 'react';

import { useNewUserAccessRights } from '@app/hooks';
import { NAccessRights } from '@app/types';

export const useRightsToSendouts = () => {
  const {
    userAccessRights: {
      Sendouts: { IsOn, IsViewReceivers, IsCreate, IsControl },
    },
    organizationAccessRights,
  } = useNewUserAccessRights();

  const hasOrganizationRightToModule = useMemo(() => {
    return organizationAccessRights?.find((right) => {
      return right?.RightType === NAccessRights.RightType.SENDOUTS;
    })?.Allowed;
  }, [organizationAccessRights]);

  const areGeneralRights = useMemo(() => {
    return (hasOrganizationRightToModule && IsOn) || false;
  }, [hasOrganizationRightToModule, IsOn]);

  const isAccessToReceiversRegistry = useMemo(
    () => areGeneralRights && IsViewReceivers,
    [areGeneralRights, IsViewReceivers]
  );
  const isAccessToSendMessageFromClients = useMemo(() => {
    return areGeneralRights && IsCreate;
  }, [areGeneralRights, IsCreate]);
  const isAccessToManageSendoutInSendouts = useMemo(
    () => areGeneralRights && IsControl,
    [areGeneralRights, IsControl]
  );

  return {
    hasOrganizationRightToModule,
    isAccessToSendoutsFromSidebar: areGeneralRights,
    isAccessToSendoutCard: areGeneralRights,
    isAccessToSendoutsRegistry: areGeneralRights,
    isAccessToReceiversRegistry,
    isAccessToSendMessageFromClients,
    isAccessToManageSendoutInSendouts,
  };
};
